export default __webpack_public_path__ + "static/media/IMG_5071.f3431280.png";